import moment from "moment";
import cn from "../../../lib/cn";
import { home } from "../../../resources/js/icons";
import P from "../../../shared/typography/P";

const statusClassName = {
    OPEN: "bg-red/10 border-red",
    RESOLVED: "bg-green-200/10 border-green-200",
};

const ReminderCard = (props) => {
    return (
        <div className="mb-2">
            <div className="flex items-center justify-between gap-1">
                <div className="flex items-center gap-1">
                    <img src={home} alt="dashboard" className="h-2" />
                    <P className="font-vietnam text-xs text-primary">
                        {props?.plantName}
                    </P>
                </div>
                <div
                    className={cn(
                        " h-2 w-2 rounded-full border",
                        statusClassName[props.status]
                    )}
                ></div>
            </div>
            <P className="font-vietnam text-xs line-clamp-2 my-0.8 text-secondary">
                {props?.message}
            </P>

            <div className="flex items-center justify-between gap-1">
                <div className="flex items-center gap-1">
                    <P className="font-vietnam text-xs text-gray-370">
                        {moment(props?.date * 1000).format("DD/MM/yyyy")}
                    </P>
                    <div className="w-0.5 h-0.5 bg-gray-370 rounded-full"></div>
                    <P className="font-vietnam text-xs text-gray-370">
                        {moment(props?.date * 1000).format("hh:mm A")}
                    </P>
                </div>
                {props.status === "OPEN" && (
                    <div className=" rounded-full">
                        <button
                            onClick={() => props.onClick(props.id)}
                            className="text-sm font-vietnam text-blue-100 "
                        >
                            Resolve
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ReminderCard;
